import React from "react";
import Changelog from "./components/changelog/Changelog";

const ChangelogPage = (props) => <Changelog {...props} />;
export default ChangelogPage;

